export default __webpack_public_path__ + "static/ccl-effaa4d64c15e0a3e772c8cdcaa07583.mp4";